/* eslint-disable @typescript-eslint/no-unused-vars */
import { CSSProperties, useContext, useState } from "react"
import { Carousel } from "react-bootstrap"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import { TPictureFile } from "../../../../globalStore/pageStore/syaryoMaster/pictureData"
import {
  syaryoMasterActions,
  TSyaryoMasterState,
} from "../../../../globalStore/pageStore/syaryoMaster/syaryoMasterStore"
import { RootState } from "../../../../globalStore/rootreducer"
import commonUtil from "../../../../ts/util/commonUtil"
import { BlobContext } from "../SyaryoMasterRegisterContext"
import FileUploadModal from "./AttachedFileModal"
import "./pictureDataPane.scss"

const pictureDetailTextStyle: CSSProperties = {
  maxWidth: "50%",
  minHeight: "5rem",
  width: "auto",
  border: "1px solid #d3d3d380",
  marginBottom: "1rem",
}

const PictureDataPane = () => {
  //#region [selector]
  const syaryoMaster: TSyaryoMasterState = useSelector(
    (state: RootState) => state.page.syaryoMaster
  )
  const disPatch: AppDispatch = useDispatch()
  const { addBlobItem, removeBlobItem, blobList } = useContext(BlobContext)

  //#endregion

  //#region [state]
  const [isShowFileUploadModal, setIsShowFileUploadModal] = useState(false)
  const [isShowDeleteFileConfirmModal, setIsShowDeleteFileConfirmModal] =
    useState(false)
  const [selected車輌写真, setSelected車輌写真] = useState<TPictureFile>()
  const [selected車輌写真Index, setSelected車輌写真Index] = useState<number>()
  //#endregion

  //#region [method]
  const add車輌写真 = async (
    file: File | undefined,
    fileUrl: string,
    comment: string
  ) => {
    if (selected車輌写真 != null) {
      const updateItem = {
        ...selected車輌写真,
        コメント: comment,
      }
      disPatch(syaryoMasterActions.edit車輌写真(updateItem))
      setSelected車輌写真(updateItem)
    } else {
      if (file != null) {
        const newFile: TPictureFile = {
          row_id: commonUtil.getUniqueStr(),
          ファイルURL: "",
          ファイル名: file.name,
          アップロード日時: "",
          コメント: comment,
          更新日時: "",
          削除フラグ: 0,
        }
        disPatch(syaryoMasterActions.add車輌写真(newFile))

        // Fileをコンテキスト経由で保持
        addBlobItem({ id: newFile.row_id!, blob: file, imageUrl: fileUrl })
      }
    }
    setIsShowFileUploadModal(false)
  }

  const remove車輌写真 = (fileData: TPictureFile) => {
    if (fileData.車輌写真ID == null) {
      // store連動
      disPatch(syaryoMasterActions.remove車輌写真(fileData))

      // コンテキスト連動
      removeBlobItem(fileData.row_id!)
    } else {
      // 既存データの場合は削除フラグ更新
      disPatch(syaryoMasterActions.edit車輌写真({ ...fileData, 削除フラグ: 1 }))
    }

    setSelected車輌写真(undefined)
    setSelected車輌写真Index(undefined)

    setIsShowFileUploadModal(false)
  }

  //#endregion

  return (
    <>
      <div className="accordion-header">
        写真
        <div className="accordion-description">車輌写真一覧</div>
      </div>
      <div>
        <h5>写真</h5>
        <div>
          <div>
            <div>
              <Button
                className="m-2"
                onClick={(e) => {
                  e.preventDefault()
                  setSelected車輌写真(undefined)
                  setSelected車輌写真Index(undefined)
                  setIsShowFileUploadModal(true)
                }}>
                追加
              </Button>
              {selected車輌写真 && (
                <Button
                  className="m-1"
                  onClick={(e) => {
                    e.preventDefault()
                    setIsShowFileUploadModal(true)
                  }}>
                  編集
                </Button>
              )}
              {selected車輌写真 && (
                <Button
                  variant="waiting"
                  className="m-4"
                  onClick={(e) => {
                    e.preventDefault()
                    setIsShowDeleteFileConfirmModal(true)
                  }}>
                  削除
                </Button>
              )}
            </div>
          </div>
        </div>
        <Container fluid>
          {/* 一覧画像 */}
          <Row>
            {syaryoMaster.車輌写真リスト
              .filter((item) => item.削除フラグ === 0)
              .map((写真, i) => {
                console.log(blobList)
                const blobListItem = blobList.find((b) => b.id === 写真.row_id)
                return (
                  <Col
                    xs={1}
                    key={i}
                    className={[
                      "file-thumbnail-col",
                      selected車輌写真Index === i ? "select-col" : "",
                    ].join(" ")}
                    onDoubleClick={() => {
                      if (selected車輌写真Index !== i) {
                        setSelected車輌写真(写真)
                        setSelected車輌写真Index(i)
                      }
                      setIsShowFileUploadModal(true)
                    }}
                    onClick={() => {
                      if (selected車輌写真Index !== i) {
                        setSelected車輌写真(写真)
                        setSelected車輌写真Index(i)
                      }
                    }}>
                    <div className="file-thumbnail-div">
                      <img
                        className="file-thumbnail"
                        src={blobListItem?.imageUrl}
                        alt={写真.ファイル名}
                      />
                    </div>
                    <span>{写真.ファイル名}</span>
                  </Col>
                )
              })}
          </Row>
          {0 <
            syaryoMaster.車輌写真リスト.filter((item) => item.削除フラグ === 0)
              .length && (
            <Row>
              <Col style={pictureDetailTextStyle}>
                <p>コメント：</p>
                {selected車輌写真 && (
                  <>
                    <pre>{selected車輌写真.コメント}</pre>
                  </>
                )}
              </Col>
            </Row>
          )}
        </Container>
      </div>

      {/* ファイル追加用モーダル */}
      <FileUploadModal
        isShow={isShowFileUploadModal}
        setIsShow={setIsShowFileUploadModal}
        addItem={add車輌写真}
        fileData={selected車輌写真}
        isShowFileImage={true}
        fileImageUrl={
          selected車輌写真 == null
            ? ""
            : blobList.find((b) => b.id === selected車輌写真.row_id)
                ?.imageUrl ?? ""
        }
        title="写真"></FileUploadModal>

      <ConfirmModal
        isShow={isShowDeleteFileConfirmModal}
        submitHandler={() => {
          remove車輌写真(selected車輌写真!)
          setIsShowDeleteFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteFileConfirmModal(false)
        }}>
        <p>選択された写真を削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
    </>
  )
}

export default PictureDataPane
